import { Pipe, PipeTransform } from '@angular/core';
import { environment } from '@environments/environment';

@Pipe({
  name: 's3Image'
})
export class S3ImagePipe implements PipeTransform {

    transform(path: string | null | undefined): string {
        if (!path) return '';
        const base = environment.s3BaseUrl.replace(/\/+$/, '');
        const cleanPath = path.replace(/^\/+/, '');
        return `${base}/${cleanPath}`;
      }

}
